import { render, staticRenderFns } from "./step_03.vue?vue&type=template&id=bbf3db28&scoped=true"
import script from "./step_03.vue?vue&type=script&lang=js"
export * from "./step_03.vue?vue&type=script&lang=js"
import style0 from "./step_03.vue?vue&type=style&index=0&id=bbf3db28&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf3db28",
  null
  
)

export default component.exports